(function () {
    'use strict';

    angular
        .module('rms-portal')
        .directive('rmsFilter', rmsFilter);

    function rmsFilter(FormBuilderService, $timeout, ListFilterStateFactory, lodash) {
        return {
            restrict: 'E',
            controller: rmsFilterCtrl,
            scope: {
                options: '=',
                filterForm: '=?',
            },
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'rms-career/components/rms-filter',
            link: function(scope, elem) {
                const vm = scope.vm;
                const showFilterButton = elem.find('.show-advance-filters');
                const advanceSearch = elem.find('.advanced-search');

                vm.onShowButtonClick = onShowButtonClick;
                vm.onSortChange = onSortChange;
                vm.searchTextChanged = searchTextChanged;

                $timeout(function() {
                    // const fbService = FormBuilderService.get(vm.filterForm.name);
                    scope.listFilterService = ListFilterStateFactory.get(scope.listFilterIdentifier);
                    scope.$watch(function() {
                        return FormBuilderService.getModel(vm.filterForm.name);
                    }, function() {
                        // do refresh grid
                        const filters = generateFilters();
                        scope.listFilterService.getFilterService().setActiveFilter('applied', filters);
                        generateSort();
                        scope.listFilterService.refreshGrid();
                    }, true);
                });

                function onShowButtonClick() {
                    if (showFilterButton.hasClass('active')) {
                        showFilterButton.removeClass('active');
                        advanceSearch.slideUp();
                    } else {
                        showFilterButton.addClass('active');
                        advanceSearch.slideDown();
                    }
                }

                function generateFilters() {
                    const formModel = FormBuilderService.getModel(vm.filterForm.name);
                    const formModelNotEmpty = lodash.omitBy(formModel, function(value) {
                       if (lodash.isNumber(value)) {
                           return false;
                       }
                       return lodash.isEmpty(value);
                    });
                    const modelKeys = lodash.keys(lodash.omit(formModelNotEmpty, ['hid_ref_form']));

                    return modelKeys.map(function(key) {
                       var modelValue =formModel[key];
                        if (!lodash.isArray(modelValue)) {
                            modelValue = [modelValue];
                        }
                       return {
                           field: key,
                           operator: 'in',
                           value: modelValue,
                       };
                    });
                }

                function onSortChange() {
                    // console.log('sort change', vm.sortBy);
                    generateSort();
                    scope.listFilterService.refreshGrid();
                    //scope.listFilterService.getGrid().dataSource.sort();
                }

                function generateSort(){
                    if (!vm.sortBy) {
                        vm.sortBy = lodash.get(vm.options,'sort_by.default_sort',null);
                    }
                    if (vm.sortBy) {
                        const sort = vm.sortBy.split('|');
                        scope.listFilterService.getGrid().dataSource.sort({field: sort[0], dir: sort[1]});
                    } else {
                        //use default
                        scope.listFilterService.getGrid().dataSource.sort({});
                    }
                }
                
                function searchTextChanged() {
                    scope.listFilterService.setSearchText(vm.searchText);
                    scope.listFilterService.refreshGrid();
                }
            }
        };
    }

    function rmsFilterCtrl($scope, lodash) {
        const vm = this;
        this.$onInit = function() {
            $scope.listFilterIdentifier = lodash.get(vm.options, 'identifier', 'default');
        }
    }
})();